import React from 'react';
import {
	Hero,
} from '../../components/component';
import Meta from '../../components/Meta';
import Characters from "../../components/characters";
import Statistic from "../../components/promo/statistic";
import Statistic_promo_2 from "../../components/promo/statistic_promo_2";
import Statistic_promo_3 from "../../components/promo/statistic_promo_3";


const Home_1 = () => {
	return (
		<main>
			<Meta title="Pelgine | Ai-Generated Pixel Art" />
			<Hero />
			<Statistic />
			<Statistic_promo_2 />
			<Statistic_promo_3 />
		</main>
	);
};

export default Home_1;
